import OrderFilmApi, { OrderFilm, OrderFilms } from '../../OrderFilmApi';

export function orderFilmsQueryKey(orderId: number): [string, number] {
    return ['getOrderFilms', orderId];
}

export function getOrderFilms(orderId: number): Promise<OrderFilm[]> {
    return OrderFilmApi.getOrderFilms(orderId).then(toFilms);
}

export function sendFilm(
    orderId: number,
    orderFilmId: number,
    email: string
): Promise<OrderFilm[]> {
    return OrderFilmApi.sendFilm(orderId, orderFilmId, email).then(toFilms);
}

export function removeFilmFile(orderId: number, orderFilmId: number): Promise<OrderFilm[]> {
    return OrderFilmApi.removeFilmFile(orderId, orderFilmId).then(toFilms);
}

function toFilms(response: OrderFilms): OrderFilm[] {
    return response && response.films ? response.films : [];
}
